module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[114]601.4292820.woff2";